module.exports = __webpack_public_path__ + "assets/img/txt-message-01.f82eafae.png";